module.exports = __webpack_public_path__ + "static/media/calendar-alt-regular.28f688cb.png";